import React, { useEffect, useMemo, useState } from 'react'
import axios from '../../../../config/axios'
import { StandardDataTable, StandardColumn, useColumnsState } from '../../../../components/StandardPage'

import { useOutletContext } from 'react-router-dom'

interface Stage {
  id: number
  name: string
}

const stageColumns: StandardColumn<Stage>[] = [
  { id: 'name', label: 'Etapa' },
  { id: 'sector', label: 'Setor', cell: () => 'Setor 1' },
  { id: 'machines', label: 'Máquinas', cell: () => 'Maquina 1' },
]

const StagesTable: React.FC = () => {
  const [stages, setStages] = useState<Stage[]>([])
  const { refresh } = useOutletContext<any>() || {}

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/production-flow/stages`)
      .then((response) => {
        if (response.data) setStages(response.data)
      })
      .catch((error) => {
        console.error(error)
      })
  }, [refresh])

  const columns = useMemo(() => stageColumns, [])
  const { columnsState, handleColumnsChange, handleRestoreColumns } = useColumnsState(
    'production_stages',
    columns,
  )

  return (
    <StandardDataTable
      tableName="Stage"
      columns={columns}
      data={stages}
      columnsState={columnsState}
      onColumnsChange={handleColumnsChange}
      onRestoreColumns={handleRestoreColumns}
      exportFileName='etapas'
      emptyMessage='Nenhuma etapa encontrada'
    />
  )
}

export default StagesTable
